<style scoped>
.two-part {
  width: 50%;
  padding: 10px;
}
.form-group:not([class*=' col-']) {
  width: 100%;
  width: 33.333333%;
  padding-left: 5px;
  padding-right: 5px;
  padding-top: -5px;
  padding-bottom: -5px;
}
</style>

<template>
  <div>
      <div class="d-flex justify-content-between">
        <div>
          <h5>Casing Hole</h5>
          <p style="font-size: 12px; margin-bottom: -1rem">
            <b-icon icon="info" variant="success"></b-icon>&nbsp;Select table
            row for more option.
          </p>
        </div>
        <div>
          <b-button-group v-if="editable">
            <b-button variant="outline-primary" size="sm" @click="refreshGrid"
              >Refresh</b-button
             >
          </b-button-group>
        </div>
      </div>
      <br />
      <div class="overflow-auto">
        <DxDataGrid
              id="casing-grid"
              ref="casingGrid"
              :data-source="casingDataSource"
              :show-borders="false"
              :show-column-lines="false"
              :show-row-lines="true"
              column-resize-mode="nextColumn"
              :allow-column-reordering="true"
              :allow-column-resizing="true"
              :cell-hint-enabled="true"
              :word-wrap-enabled="true"
              :column-auto-width="false"
              :column-width="100"
              :height="300"
              @row-inserted="savedRows"
              @row-updated="updatedRows"
              @row-removed="removedRows"
              @selection-changed="onSelectionChanged"
            >
              <DxPaging :enabled="true" :page-size="5" />
              <DxScrolling column-rendering-mode="virtual"/>
              <DxSelection mode="single"/>
              <DxEditing
                :allow-updating="true"
                :allow-adding="true"
                :allow-deleting="true"
                :use-icons="true"
                mode="row"/>
              <DxColumn
                type="buttons"
                width="5%"
              >
                <GridButton name="edit"/>
                <GridButton name="delete"/>
              </DxColumn>
              <DxColumn caption="No." cell-template="rowNoTemplate" width="5%" />
              <template #rowNoTemplate="{ data }">
                {{ data.rowIndex + 1 }}
              </template>
              <DxColumn :width="200" :visible="true" data-field="holeSize" data-type="string" caption="Hole Size">
                <DxLookup
                    :data-source="optionsComboHoleSize"
                    value-expr="value"
                    display-expr="text"/>
              </DxColumn>
              <DxColumn :width="200" :visible="true" data-field="casingSize" data-type="string" caption="Casing Size">
                <DxLookup
                    :data-source="optionsComboCasingSize"
                    value-expr="value"
                    display-expr="text"/>
              </DxColumn>
              <DxColumn :width="200" :visible="true" data-field="tabularType" data-type="string" caption="Tubular Type">
                <DxLookup
                    :data-source="optionsComboTabularType"
                    value-expr="value"
                    display-expr="text"/>
              </DxColumn>
              <DxColumn :visible="true" data-field="startMd" data-type="numeric" caption="Start MD" />
              <DxColumn :visible="true" data-field="endMd" data-type="numeric" caption="End MD" />
              <DxColumn :visible="true" data-field="perforated" data-type="string" caption="Perforated" >
                <DxLookup
                    :data-source="optionsPerforation"
                    value-expr="value"
                    display-expr="text"/>
              </DxColumn>
        </DxDataGrid>
        <CasingTally
          v-if="selectedRow.length > 0"
          :hole-id="selectedHoleId"
          :editable="editable"
        />
      </div>
  </div>
</template>

<script>
import Vue from 'vue'
import VueFormGenerator from 'vue-form-generator'
import 'vue-form-generator/dist/vfg.css'
import { formComputed, formMethods } from '@state/helpers'
import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue'
import CasingTally from '@components/form/drilling-activity/casing-tally'
import {
  DxDataGrid,
  DxColumn,
  DxPaging,
  DxEditing,
  DxFormItem,
  DxLookup,
  DxSelection,
  DxScrolling,
  DxButton as GridButton
} from 'devextreme-vue/data-grid'
import notify from "devextreme/ui/notify"
import CustomStore from 'devextreme/data/custom_store'
import mapApiUrl from '@/src/utils/api-mapper'
import axios from 'axios'
import qs from 'querystring'
// import DxButton from 'devextreme-vue/button'

Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)

Vue.use(VueFormGenerator)

export default {
  components: { 
    CasingTally,
    DxDataGrid,
    DxColumn,
    DxPaging,
    DxEditing,
    DxSelection,
    DxScrolling,
    GridButton,
    // DxFormItem,
    DxLookup,
    // DxForm,
    // DxSimpleItem,
    // DxGroupItem,
    // DxButton 
    },
  props: {
    // eslint-disable-next-line vue/require-default-prop
    submitId: Number,
    editable: Boolean,
  },
  data() {
    return {
      selectedHoleId: undefined,
      selectedRow: [],
      casingData: [],
      casingDataSource: null,
      optionsComboHoleSize: [],
      confirmSubmit: false,
      optionsComboCasingSize: [],
      optionsComboTabularType: [],
      optionsPerforation: [{text: 'Yes', value: 'Perforated'}, {text: 'No', value: 'Un-Perforated'}],
      perforatedString: 'Un-Perforated',
      form: {},
      show: true,
      selectedAction: '',
      disbledPerforated: false,
      disabledStartMd: false,
      tableBusy: false,
      tableFields: [
        { key: 'holeSize', label: 'Hole Size', type: 'string' },
        {
          key: 'casingSize',
          label: 'Casing Size',
          sortable: true,
          thClass: 'nowrap',
          tdClass: 'nowrap',
        },
        {
          key: 'tabularType',
          label: 'Tubular Type',
          sortable: true,
          thClass: 'nowrap',
          tdClass: 'nowrap',
        },
        {
          key: 'startMd',
          label: 'Start MD',
          sortable: true,
          thClass: 'nowrap',
          tdClass: 'nowrap',
        },
        {
          key: 'endMd',
          label: 'End MD',
          sortable: true,
          thClass: 'nowrap',
          tdClass: 'nowrap',
        },
        {
          key: 'perforated',
          label: 'Perforated',
          sortable: true,
          thClass: 'nowrap',
          tdClass: 'nowrap',
        },
      ],
      perPage: 10,
      currentPage: 1,
    }
  },
  computed: {
    ...formComputed,
    totalRows() {
      if (this.casingData) return this.casingData.length
      else return 0
    },
  },
  watch: {
    submitId: function (value) {
      this.refreshGrid()
    },
    editable: function () {},
  },
  created: function () {
    this.init()
    this.loadAllCombo()
  },
  methods: {
    ...formMethods,
    init() {
      this.casingDataSource = new CustomStore({
        key: 'intId',
        load: () => {
          const url = mapApiUrl('/api/form/activity/casing/review/submit')
          const params = {submitId: this.submitId, status: 1}
          return axios.get(url, {params: params}).then(response => response.data.data)
        },
        onLoaded: (result) => {
            // Result is the array of data received from your backend
            console.log("Store received this data:", result);
            
            // Check if the first item actually contains your key
            if (result && result.length > 0) {
                console.log("Sample item structure:", result[0])
            }
        },
        insert: (values) => {
          values.submitId = this.submitId
          if (isNaN(values.id)) {
            delete values.id
          }
          const url = mapApiUrl('/api/form/activity/casing/add')
          return axios.post(url, qs.stringify(values)).then(response => response) 
        },
        update: (key, values) => {
          values.submitId = this.submitId
          values.id = key
          const url = mapApiUrl('/api/form/activity/casing/add')
          return axios.post(url, qs.stringify(values)).then(response => response) 
        },
        remove: (key) => {
          const url = mapApiUrl('/api/form/activity/casing/remove')
          return axios.delete(url, {params: {intId: key}})
        },
      })
    },
    refreshGrid() {
      this.$refs.casingGrid.instance.refresh()
    },
    savedRows(e) { // e.data value is whatever customstore object returns
      notify({ message: `Casing hole data has been recorded.`, width: 500 }, 'success', 3000)
    },
    updatedRows(e) { // e.data value is whatever customstore object returns
      notify({ message: `Casing hole data has been updated.`, width: 500 }, 'success', 3000)
    },
    removedRows(e) { // e.data value is whatever customstore object returns
      notify({ message: `Casing hole data has been removed.`, width: 500 }, 'success', 3000)
    }, 
    refreshTable() {
      this.retrieveDataTable()
    },
    onSelectionChanged(event) {
      this.selectedRow = event.selectedRowsData
      this.selectedHoleId = event.selectedRowsData[0] !== undefined ? event.selectedRowsData[0].intId : undefined
    },
    onRowSelected(items) {
      this.selectedRow = []
      if (items.length > 0) {
        this.selectedRow = items
        this.form = items[0]
      }
    },
    loadAllCombo() {
      this.loadComboHoleSize()
      this.loadComboCasingSize()
      this.loadComboTabularType()
    },
    retrieveDataTable() {
      this.casingData = []
      this.tableBusy = true
      if (this.submitId) {
        this.getActivityCasingList({
          params: { submitId: this.submitId, status: 1 },
        }).then((resp) => {
          if (resp) {
            this.casingData = resp.data.data
            let idx = 1
            this.casingData.forEach(element => {
              element.id = idx++
            })
          }
        })
        this.tableBusy = false
      }
    },
    onSaveOrUpdate(e) {
      let rowData = {}
      if (Array.isArray(e.changes)) {
        rowData = {...e.changes[0].data}        
      } else {
        rowData = {...e.changes.data}
      }
      delete rowData.id
      rowData.submitId = this.submitId
      rowData.perforated = rowData.perforated ? 'Perforated' : 'Un-Perforated'
      this.addActivityCasing({ params: rowData }).then((resp) => {
          this.retrieveDataTable()
          notify({ message: 'Data has been recorded.', width: 300 }, 'success', 5000)
      })
    },
    convertNomSize(nom) {
      if (!isNaN(nom)) return nom
      let sizeStrings = nom.split(" ")
      let sizeValue = parseFloat(sizeStrings[0])
      if (sizeStrings.length > 1) {
        let element = sizeStrings[1].split("/")
        let elementsValue = parseFloat(element[0]) / parseFloat(element[1])
        sizeValue += elementsValue
      }
      return sizeValue
    },
    loadComboHoleSize() {
      this.getComboListWorkstringSize({ params: {} }).then((resp) => {
        let _arrData = resp.data.data
        _arrData.sort((x,y)=>this.convertNomSize(x.comboValue)-this.convertNomSize(y.comboValue))
        this.optionsComboHoleSize = []
        for (var i = 0; i < _arrData.length; i++) {
          let _temp = {
            value: _arrData[i].comboId,
            text: _arrData[i].comboValue,
          }
          this.optionsComboHoleSize.push(_temp)
        }
      })
    },
    loadComboCasingSize() {
      this.getComboListCasingSize({ params: {} }).then((resp) => {
        let _arrData = resp.data.data
        this.optionsComboCasingSize = []
        for (var i = 0; i < _arrData.length; i++) {
          let _temp = {
            value: _arrData[i].comboId,
            text: _arrData[i].comboValue,
          }
          this.optionsComboCasingSize.push(_temp)
        }
      })
    },
    loadComboTabularType() {
      this.getComboListTabularType({ params: {} }).then((resp) => {
        let _arrData = resp.data.data
        this.optionsComboTabularType = []
        for (var i = 0; i < _arrData.length; i++) {
          let _temp = {
            value: _arrData[i].comboId,
            text: _arrData[i].comboValue,
          }
          this.optionsComboTabularType.push(_temp)
        }
      })
    },
    makeToast(msg) {
      this.$bvToast.toast(msg, {
        title: 'Notification',
        autoHideDelay: 5000,
        appendToast: false,
      })
    },
    async changeOptionPerforated(val) {
      //   this.perforatedString = val
    },
    doConfirm() {
      this.confirmSubmit = true
    },
    tubularChanged(val) {
      if (val === 'Liner') {
        this.disbledPerforated = false
        this.form.startMd = ''
        this.form.perforated = 'Un-Perforated'
        this.perforatedString = 'Un-Perforated'
        this.form.perforated = ''
        this.disabledStartMd = false
      } else {
        this.disbledPerforated = false
        this.form.startMd = 0
        this.disabledStartMd = true
      }
    },
  },
}
</script>